export default build =>
    build.mutation({
        query(payload) {
        //    console.log("payload",payload)
            return {
                url: '/school/createPhotoGalleryYear',
                method: 'POST',
                body: payload,               
            };
        },
        invalidatesTags: ['photogallery'],
    })
